import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20fashion%20and%20lifestyle%20composition%20with%20athletic%20sneakers%20casual%20hoodies%20caps%20bags%20and%20accessories%20artistically%20arranged%20on%20warm%20terracotta%20and%20sand%20gradient%20background%2C%20golden%20hour%20ambient%20lighting%20casting%20long%20soft%20shadows%2C%20editorial%20product%20photography%2C%20modern%20urban%20aesthetic%2C%20rich%20warm%20tones%2C%20harmonious%20balanced%20layout%2C%20high%20detail%20texture%20visible%20on%20every%20product&width=1600&height=900&seq=hero-main-2026-v2&orientation=landscape"
          alt="USFansSpreadsheet - moda i akcesoria"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 pt-24 md:pt-28 pb-12 flex flex-col items-center text-center">
        <div className="mb-8" ref={dropdownRef}>
          <div className="relative inline-block">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-2 px-5 py-2.5 bg-background-50/90 backdrop-blur-sm border border-background-200/60 rounded-full text-sm font-medium text-foreground-800 hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>Wybierz kategorię</span>
              <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 w-64 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden z-20 max-h-80 overflow-y-auto">
                {categories.map((cat, i) => (
                  <a
                    key={i}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5 max-w-3xl">
          USFansSpreadsheet Polska – Największy przewodnik i porównanie 2026
        </h1>

        <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-2xl leading-relaxed">
          Odkryj najlepsze arkusze USFansSpreadsheet, porównaj opcje i znajdź najbardziej aktualne rozwiązania dla wszystkich kategorii.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mb-6">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            usfans spreadsheet
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 bg-transparent border-2 border-background-50 text-background-50 text-sm font-semibold rounded-full hover:bg-background-50 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            buy it now
            <i className="ri-shopping-bag-line text-base"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-4">
          {[
            { icon: "ri-check-line", text: "Aktualizowane regularnie" },
            { icon: "ri-shield-check-line", text: "Niezależne recenzje" },
            { icon: "ri-lock-line", text: "Bezpieczne korzystanie" },
            { icon: "ri-book-open-line", text: "Darmowe poradniki" },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-1.5 text-background-200/80 text-xs md:text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-primary-400 text-sm`}></i>
              </div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}